<template>
  <div class="navbar">
    <input
      v-for="(item, index) in navbarItems"
      :id="`tab${index + 1}`"
      :key="index"
      v-model="radioTab"
      :value="item.activeTab"
      type="radio"
      name="tab"
      :disabled="item.activeTab === 'earn'"
    />

    <label
      v-for="(item, index) in navbarItems"
      :key="index"
      :for="`tab${index + 1}`"
      data-attr="Select-Navbar-Item"
      :data-attr-property="JSON.stringify({ goTo: item.activeTab })"
      :class="[
        `label${index + 1}`,
        {
          'is-home': item.activeTab === '/',
          'is-active': item.activeTab === user.navbarTab,
          'active-tab':
            (!user.loading &&
              user.firstVisit &&
              item.activeTab === 'leader-board' &&
              user.navbarTab === '/') ||
            (!user.loading &&
              user.firstVisit &&
              item.activeTab === 'profile' &&
              user.navbarTab === 'leader-board') ||
            (!user.loading &&
              user.firstVisit &&
              item.activeTab === '/' &&
              user.navbarTab === 'profile'),
        },
      ]"
      @click="handleTabChange(item)"
    >
      <div
        :class="{
          notification:
            (indicators.dailySpinCount[0].value === 0 &&
              item.title == 'SPIN') ||
            (user.isNewLeaderBoardPrize && item.title == 'RANKS') ||
            (user.isFriendNotification && item.title == 'FRIENDS') ||
            (item.title === 'SHOP' && !user.isVisitShop),
        }"
      >
        <img
          class="icon"
          :src="item.activeTab === 'profile' ? profilePicture : item.src"
          :class="[
            `icon${index + 1}`,
            { 'is-active': item.activeTab === user.navbarTab },
          ]"
          :data-tab="item.activeTab"
        />
      </div>
      <!-- <p v-if="item.activeTab === user.navbarTab && item.title !== 'HOME'">
        {{ item.title }}
      </p> -->
    </label>

    <div class="line" />
  </div>
</template>

<script setup>
import Earn from '~/assets/images/earn.svg'
import Shop from '~/assets/images/shop.svg'
import SpinWheel from '~/assets/images/spin-icon.svg'
import Home from '~/assets/images/home.svg'
import Chart from '~/assets/images/chart.svg'
import Friends from '~/assets/images/friends.svg'

// component doesn't use incoming props; navbar items are internal

const user = useUserStore()
await user.profile()
const audioStore = useAudioStore()

const profilePicture = computed(() => user.user.avatar.photoUrl)

const navbarItems = [
  { title: 'TASKS', src: Earn, activeTab: 'achievements' },
  { title: 'FRIENDS', src: Friends, activeTab: 'invite-friend' },
  { title: 'SHOP', src: Shop, activeTab: 'shop' },
  { title: 'HOME', src: Home, activeTab: '/' },
  { title: 'SPIN', src: SpinWheel, activeTab: 'spin-wheel' },
  { title: 'RANKS', src: Chart, activeTab: 'leader-board' },
  { title: 'PROFILE', src: profilePicture.value, activeTab: 'profile' },
]

const indicators = useIndicatorsStore()

const radioTab = ref(user.navbarTab)

watch(
  () => user.navbarTab,
  (val) => {
    radioTab.value = val
  },
  { immediate: true },
)

function handleTabChange(item) {
  if (item.activeTab === user.navbarTab) return

  if (user.firstVisit) {
    if (user.navbarTab === '/') {
      user.navbarTab = 'leader-board'
      navigateTo('leader-board', { replace: true })
    } else if (user.navbarTab === 'leader-board') {
      user.navbarTab = 'profile'
      navigateTo('profile', { replace: true })
    } else if (user.navbarTab === 'profile') {
      user.navbarTab = '/'
      navigateTo('/', { replace: true })
    }
  } else {
    navigateTo(item.activeTab, { replace: true })
    user.loading = true
    user.changeNavbarTab(item.activeTab)

    if (item.activeTab === '/') {
      indicators.getIndicators()
    }
  }
  audioStore.playSound('navbarSound')
}

// `.line` positioning is handled by CSS using the checked radio input
// (see input #tabN:checked ~ .line rules). We use `v-model` on radios
// so the checked state reflects `user.navbarTab` immediately.
</script>

<style lang="scss" scoped>
.navbar {
  width: 93%;
  height: 55px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 10px;
  border-radius: 18px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background-color: #2a2e33;
  margin: 0 auto;
  z-index: 100;
  max-width: $sm;
  overflow: hidden;

  input {
    display: none;

    @for $i from 1 through 7 {
      &#tab#{$i}:checked {
        ~ .line {
          left: #{($i - 1) * 14.28% + 7.14%};
          transform: translateX(-50%);
        }
      }
    }
  }

  label {
    display: grid;
    place-items: center;
    font-size: 10px;
    // height: 63px;
    width: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
    position: relative;
    // top: 12px;
    transition: all 0.3s ease;
    cursor: pointer;
    gap: 5px;

    p {
      margin-top: 4px;
      font-size: 12px;
      color: #8d8d8d;
      transition: color 0.25s ease;
    }

    &.is-disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    &.is-home {
      // width: 70px;
      width: 100%;
      margin: 0;
      height: 64px;
      border-radius: 12px;
      // border: 2px solid #8d8d8d;

      // margin: 0 10px;

      .icon {
        transform: scale(1.5) !important;
      }
    }

    &.is-active {
      p {
        color: #fff;
      }

      .icon {
        transform: scale(1.2);

        &:not(.icon7) {
          filter: brightness(0) saturate(100%) invert(84%) sepia(22%)
            saturate(6592%) hue-rotate(2deg) brightness(108%) contrast(102%);
        }
      }

      &::before {
        content: '';
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        width: 75px;
        height: 55px;
        pointer-events: none;
        z-index: -110;
        clip-path: polygon((0 0, 100% 0, 80% 100%, 20% 100%));
        opacity: 0.2;
        background: linear-gradient(
          to top,
          #ffc107 0.01%,
          rgba(255, 193, 7, 0) 40%
        );
      }
    }
  }

  .line {
    position: absolute;
    height: 3px;
    background: #ffcc00;
    bottom: 0;
    width: 45px;
    left: 7.14%;
    transform: translateX(-50%);
    transition: 0.25s ease;
  }

  .icon {
    margin: 0 auto;
    position: relative;
    top: 0;
    padding: 10px;
    transition:
      transform 0.25s ease,
      filter 0.25s ease;

    &.icon4 {
      top: 0px !important;
    }

    &.icon7 {
      border-radius: 50%;
      width: 48px;
      height: 48px;
    }
  }

  .notification {
    position: relative;
    display: inline-block;

    &::before {
      content: '';
      position: absolute;
      top: -4px;
      right: -4px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }

    // &::after {
    //   content: '';
    //   position: absolute;
    //   top: 0px;
    //   right: 0px;
    //   width: 10px;
    //   height: 8px;
    //   border-radius: 50%;
    //   border: 2px solid rgb(46, 46, 46);
    // }
  }

  .active-tab {
    border-radius: 100%;
    box-shadow: 0px 0px 10px 6px #ffffff49;
    background: #ffffff49;
  }

  .active-tab::after {
    content: '';
    display: inline-block;
    position: absolute;
    background: url('~/assets/images/hand2.png') no-repeat;
    width: 100%;
    height: 100%;
    background-position: 12px 20px;
    animation: hand 1.5s ease-in-out infinite;
  }

  @keyframes hand {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  @media screen and (min-width: 530px) {
    .hand-icon {
      right: calc(($sm / 6) - 20px);
    }
  }
}
</style>
